import { useQueryClient } from "@tanstack/react-query";
import { useOnPageExit } from "PFCore/hooks/use_on_page_exit";

const ADMIN_ROUTES = ["/admin", "/saas_admin"];

const isAdminRoute = (pathname: string) => ADMIN_ROUTES.some((adminRoute) => pathname.startsWith(adminRoute));

export const useInvalidateOnAdminExit = () => {
  const queryClient = useQueryClient();

  const onAdminExit = () => queryClient.invalidateQueries();

  useOnPageExit(isAdminRoute, onAdminExit);
};
